// import all 3rd party dependencies
import { default as angular } from 'angular';
import { default as uiBootstrap } from 'angular-ui-bootstrap';

// only import the font awesome icons that are in use
import { library, dom, config } from '@fortawesome/fontawesome-svg-core';
import { faXTwitter, faFacebook, faFacebookSquare, faInstagram, faLinkedinIn, faYoutube, faTiktok, faWhatsapp, faFacebookMessenger } from '@fortawesome/free-brands-svg-icons';
import {
    faExclamationTriangle, faChevronLeft, faChevronRight, faQuestionCircle, faCircleXmark,
    faCloudDownload, faLocationArrow, faCommentAltExclamation, faXmark, faTrash, faHeart,
    faPlus, faUser, faInfoCircle, faSort, faCircleNotch, faFileDownload, faCalendar, faSearch,
    faBars, faTh, faPaperPlane, faUsers, faEdit, faSignIn, faDesktop, faFilePdf, faDownload,
    faExternalLinkSquare, faInfoSquare, faSpinner, faCalendarDay, faCommentAltCheck,
    faPlusCircle, faStar, faQuestion, faCheck, faHomeAlt, faChevronDown, faGraduationCap,
    faArrowRight, faCommentAlt, faMapMarkerAlt, faClock, faPortalExit, faPlayCircle,
    faBallotCheck, faUsdCircle, faArrowToBottom, faAddressCard, faFilter, faLink,
    faEnvelope, faShare
} from '@fortawesome/pro-light-svg-icons';

// we provide the required css in base bundle
config.autoAddCss = false;

// add social icons to sub-setted library
library.add(faXTwitter, faFacebook, faFacebookSquare, faInstagram, faLinkedinIn, faYoutube, faTiktok, faWhatsapp, faFacebookMessenger);

// add general UI icons to sub-setted library
library.add(
    faExclamationTriangle, faChevronLeft, faChevronRight, faQuestionCircle, faCircleXmark,
    faCloudDownload, faLocationArrow, faCommentAltExclamation, faXmark, faTrash, faHeart,
    faPlus, faUser, faInfoCircle, faSort, faCircleNotch, faFileDownload, faCalendar, faSearch,
    faBars, faTh, faPaperPlane, faUsers, faEdit, faSignIn, faDesktop, faFilePdf, faDownload,
    faExternalLinkSquare, faInfoSquare, faSpinner, faCalendarDay, faCommentAltCheck,
    faPlusCircle, faStar, faQuestion, faCheck, faHomeAlt, faChevronDown, faGraduationCap,
    faArrowRight, faCommentAlt, faMapMarkerAlt, faClock, faPortalExit, faPlayCircle,
    faBallotCheck, faUsdCircle, faArrowToBottom, faAddressCard, faFilter, faLink,
    faEnvelope, faShare
);

// watch for changes
dom.watch();

import $ from 'jquery';
import 'angular-route';
import 'angular-animate';
import 'angular-sanitize';
import 'bootstrap/dist/js/bootstrap.bundle';

window.jQuery = $;
window.$ = $;

// import our bits
import 'Scripts/site.js';

import searchModule from '../_searchModule/_search.js';

// import and build the core js module
import coreControllers from './controllers/_controllers';
import coreDirectives from './directives/_directives';
import coreFilters from './filters/_filters';
import coreServices from './services/_services';

const coreModule = 'usc.core';

angular.module(coreModule, [
    coreControllers,
    coreDirectives,
    coreFilters,
    coreServices
]);

// don't bootstrap anything yet => it's done in the view, after all modules have been loaded
// otherwise, bootstrapping the app here means we can't use .requires.push() for other modules
// which largely defeats the purpose of making everything more modular

window.uscApp = 'Uscapp';

angular.module(window.uscApp,
    [
        'ngAnimate',
        'ngSanitize',
        uiBootstrap,
        coreModule,
        searchModule
    ])
    .constant('$constants',
        {
            'MAPS_KEY': 'AIzaSyBM5H_ROFfFnljp5hajm0mtMIgQSevatOU'
        })
    .config(['$uibTooltipProvider', $uibTooltipProvider => {
        $uibTooltipProvider.options({
            popupDelay: 200,
            appendToBody: true
        });
    }])
    .config(['uibDropdownConfig', uibDropdownConfig => {
        uibDropdownConfig.openClass = 'show'
    }])
    .run(['$templateCache', $templateCache => {
        $templateCache.put('group-template.html',
            `<div class="card-header">
                <h2 class="mb-0">
                    <button tabindex="0" class="btn btn-link" ng-click="toggleOpen()" uib-accordion-transclude="heading">
                        <span uib-accordion-header>{{ heading }}</span>
                        <i class="fal fa-chevron-down ml-auto"></i>
                    </button>
                </h2>
            </div>
            <div class="collapse" uib-collapse="!isOpen">
                <div class="card-body" ng-transclude></div>
            </div>`);
    }]);
